import request from '@/utils/request'

export function epmsa230List(param) {
  let data = param
  return request({
    url: `/outsoucingBlockControl/epmsa230/epmsa230List`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

export function epmsa230Head(param) {
  let data = param
  return request({
    url: `/outsoucingBlockControl/epmsa230/epmsa230Head`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

export function epmsa230Detail(param) {
  let data = param
  return request({
    url: `/outsoucingBlockControl/epmsa230/epmsa230Detail`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

export function epmsa230Machine(param) {
  let data = param
  return request({
    url: `/outsoucingBlockControl/epmsa230/epmsa230Machine`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

export function epmsa230save(param) {
  let data = param
  return request({
    url: `/outsoucingBlockControl/epmsa230/epmsa230save`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

export function epmsa230cancel(param) {
  let data = param
  return request({
    url: `/outsoucingBlockControl/epmsa230/epmsa230cancel`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}




